import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Injectable()
export class RoleGuardService implements CanActivate {
  // expectedRole = 'admin';
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  role = 'admin';
  constructor(public router: Router, private _snackBar: MatSnackBar) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    // this will be passed from the route config
    // on the data property
    const expectedRole = route.data.expectedRole;

    console.log(expectedRole);
    // this.role !== this.expectedRole
    if (this.role !== expectedRole) {
      void this.router.navigate(['home']);
      this.openSnackBar('You are not allowed to navigate to this page', 'Ok');
      return false;
    }
    return true;
  }

  openSnackBar(message: string, action: string): void {
    this._snackBar.open(message, action, {
      duration: 1000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
}
